import * as Mod1 from "./discourse/initializers/add-noindex-item-to-topic-wrench-menu";
const compatModules = {
  "discourse/initializers/add-noindex-item-to-topic-wrench-menu": Mod1,
};
export { compatModules };
export default compatModules;
